import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=fabdcc1a&scoped=true"
import script from "./eventList.vue?vue&type=script&lang=js"
export * from "./eventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabdcc1a",
  null
  
)

export default component.exports